// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"80e0156f","180":"0fce3fbc","202":"c992c498","360":"b16ccb5b","611":"9cf1e702","645":"0ec5be7b","900":"8483a00a"}[chunkId] + ".chunk.js";
};